"use client";

import { useCallback, useState, useRef } from "react";
import slug from "slug";

export default function SlugGeneratorClient() {
  const textRef = useRef<any>(null);
  const [slugText, setSlug] = useState("");

  const slugifyText = useCallback(() => {
    setSlug(slug(textRef.current.value));
  }, []);

  return (
    <div className="flex justify-center bg-white dark:bg-neutral overflow-x-hidden">
      <div className="flex flex-col items-center w-full max-w-screen-3xl min-h-[500px] p-4 md:p-10">
        <h1 className="text-4xl font-bold text-center my-4">
          URL Slug Generator - Create SEO-Friendly Web Addresses
        </h1>
        <div>
          <p className="text-center mb-10 lg:w-2/3 mx-auto">
            Effortlessly optimize your website URLs with our URL slug
            generator tool. Convert any text into clean, SEO-friendly URL
            slugs that boost search engine visibility and readability. Ideal
            for blogs, articles, and product pages, our tool helps you get
            found online easier. Try it now!
          </p>
        </div>
        <div className="w-full flex flex-col items-center">
          <div className="flex w-full mb-8 max-w-3xl select-none">
            <input
              ref={textRef}
              className="input input-bordered mb-4 w-full placeholder:italic text-base p-4 mr-2"
              placeholder="Enter text to convert..."
            />
            <button
              className="btn btn-info text-white ml-4"
              onClick={slugifyText}
            >
              Slugify
            </button>
          </div>
          <div className="text-3xl mt-20 mb-32 max-w-3xl">{slugText}</div>
        </div>
      </div>
    </div>
  );
}
